import { render, staticRenderFns } from "./ChatClients.vue?vue&type=template&id=ee94f94c"
import script from "./ChatClients.vue?vue&type=script&lang=js"
export * from "./ChatClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports